import React, { FC } from 'react';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import { biEvents } from 'api/bi-events';
import { BI_ACTION_NAME, BI_STEP_NAME } from 'config/bi';
import { isExistingSiteEntryMode } from 'config/entry-mode';
import { StepId } from 'config/steps';
import { useOrchestratorNavigation } from '@wix/gg-components/orchestrator';
import styles from '../LandingPageStep.scss';
import { HeaderLogo } from 'components/Header/HeaderLogo';
import { useAppStore } from 'stores/appStore';

export const LandingPageStepContent: FC = () => {
  const { t } = useTranslation();
  const { next } = useOrchestratorNavigation();
  const isExistingSiteMode = useAppStore((state) => isExistingSiteEntryMode(state.entryMode));
  const contentKeyPrefix = isExistingSiteMode ? 'existing-user-landing-page-step' : 'landing-page-step';

  const handlePrimaryButtonClick = () => {
    biEvents.actionClicked({
      screenName: BI_STEP_NAME[StepId.LandingPage],
      action: BI_ACTION_NAME.CONTINUE,
    });
    next();
  };

  return (
    <div className={styles.landingPageStepContent}>
      <HeaderLogo />
      <div className={styles.landingPageStepContentTypography}>
        <p className={styles.landingPageStepContentTitle}>
          <Trans i18nKey={`${contentKeyPrefix}.title`} components={{ br: <br /> }} />
        </p>
        <p className={styles.landingPageStepContentDescription}>
          <Trans i18nKey={`${contentKeyPrefix}.description`} components={{ br: <br /> }} />
        </p>
      </div>
      <button className={styles.landingPageStepContentButton} onClick={handlePrimaryButtonClick}>
        {t(`${contentKeyPrefix}.primary-button`)}
      </button>
    </div>
  );
};
